import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.004 18.977a.843.843 0 0 1-1.23 0l-2.626-2.625a.843.843 0 0 1 0-1.23l2.625-2.626a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23l-1.12 1.149h5.742c.984 0 1.75-.793 1.75-1.75v-.875c0-.492.41-.875.875-.875.492 0 .875.383.875.875v.875c0 1.914-1.559 3.5-3.5 3.5H8.883l1.12 1.121a.843.843 0 0 1 0 1.23m2.625-7a.843.843 0 0 1-1.23 0L8.772 9.352a.843.843 0 0 1 0-1.23l2.625-2.626a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23l-1.12 1.149H15.5c.492 0 .875-.41.875-.875v-.875c0-.492.41-.875.875-.875.492 0 .875.383.875.875V7A2.626 2.626 0 0 1 15.5 9.625h-3.992l1.12 1.121a.843.843 0 0 1 0 1.23"
    }, null, -1)
  ]))]))
}
export default { render: render }